import React from "react";
import image from "../assets/images/bear.svg";
import styles from "../styles/LiveCard.module.css";
import { withRouter } from "react-router-dom";
const LiveCard = () => {
  return (
    <div className={styles.Tradathon__LiveCard}>
      <div className={styles.Tradathon__LiveCard_children}>
        <div className="skeleton text" style={{ width: "150px" }} />

        <div className="skeleton text" style={{ width: "150px" }} />

        <div className="skeleton text" style={{ width: "150px" }} />
      </div>
      <div className={styles.Tradathon__LiveCard_children}>
        <div className="skeleton text" style={{ width: "150px" }} />

        <img
          src={image}
          alt="bull/bear"
          className={styles.Tradathon__LiveCard_image}
        />

        <div className="skeleton text" style={{ width: "100%" }} />

        <div className="skeleton text" style={{ width: "150px" }} />
      </div>
      <div className={styles.Tradathon__LiveCard_children}>
        <>
          <div className="skeleton text" style={{ width: "150px" }} />
        </>

        <>
          <div className="skeleton text" style={{ width: "150px" }} />
        </>

        <div className="skeleton text" style={{ width: "150px" }} />

        <div className="skeleton text" style={{ width: "150px" }} />
      </div>
      <div className={styles.mobile__view}>
        <div>
          <div className="skeleton text" style={{ width: "150px" }} />

          <div className="skeleton text" style={{ width: "150px" }} />

          <div className="skeleton text" style={{ width: "150px" }} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          <>
            <div className="skeleton text" style={{ width: "150px" }} />
          </>

          <>
            <div className="skeleton text" style={{ width: "150px" }} />
          </>

          <div className="skeleton text" style={{ width: "150px" }} />

          <div className="skeleton text" style={{ width: "150px" }} />
        </div>
      </div>

      <div className="shimmer-wrapper">
        <div className="shimmer"></div>
      </div>
    </div>
  );
};

export default withRouter(LiveCard);
